import { Button } from '@elipssolution/harfang';
import { Drawer, DrawerProps, Stack, styled, Typography } from '@mui/material';
import getConfig from 'next/config';

import IOSPlusIcon from '../../../../assets/icons/IOSPlusIcon';
import IOSShareIcon from '../../../../assets/icons/IOSShareIcon';
import usePWA from '../../../../hooks/usePWA';
import { PublicRuntimeConfigType } from '../../../types/publicRuntimeConfig';

const PromptDrawer = styled(Drawer)(({ theme: { shape, spacing } }) => ({
	overflow: 'hidden',
	zIndex: 1402,

	'& .MuiPaper-root': {
		overflow: 'hidden',
		zIndex: 1403,
		padding: spacing(1.5, 1.5, 0, 1.5),
		paddingBottom: `calc(${spacing(2)} + env(safe-area-inset-bottom))`,
		display: 'flex',
		gap: spacing(2),
	},

	'& .MuiDrawer-paperAnchorBottom': {
		borderTopLeftRadius: shape.borderRadius * 2,
		borderTopRightRadius: shape.borderRadius * 2,
	},
}));

type PwaInstallPromptDrawerProps = {
	open: DrawerProps['open'];
	onClose: () => void;
};

const PwaInstallPromptDrawer = ({ open, onClose }: PwaInstallPromptDrawerProps) => {
	const {
		publicRuntimeConfig: { appName },
	} = getConfig() as PublicRuntimeConfigType;

	const { isIOS, isAndroid, installPWA, isInstalled } = usePWA();

	return (
		<PromptDrawer open={open} onClose={onClose} anchor="bottom" disablePortal>
			<Typography variant="subtitle1" fontWeight={500}>
				{isInstalled ? `${appName} est installé !` : `Installer ${appName}`}
			</Typography>

			<Typography paddingBottom={2}>
				{isInstalled
					? "Si vous avez été jusqu'au bout du processus, vous pouvez maintenant retourner sur votre écran d'accueil pour ouvrir l'application. Sinon, rechargez la page pour recommencer."
					: `Profitez d'une expérience améliorée en ajoutant ${appName} sur votre écran d'accueil.`}
			</Typography>

			{!isInstalled && (
				<>
					{isIOS && (
						<Stack gap={2}>
							<Stack flexDirection="row" alignItems="center" gap={2}>
								<Typography>1)</Typography>
								<IOSShareIcon height={26} />
								<Typography variant="body2">
									Appuyez sur le bouton <b>&quot;Partager&quot;</b>
								</Typography>
							</Stack>

							<Stack flexDirection="row" alignItems="center" gap={2}>
								<Typography>2)</Typography>
								<IOSPlusIcon height={18} />
								<Typography variant="body2">
									Sélectionnez <b>&quot;Sur l&apos;écran d&apos;accueil&quot;</b>
								</Typography>
							</Stack>
						</Stack>
					)}

					{isAndroid && (
						<Button onClick={installPWA} variant="contained">
							Installer
						</Button>
					)}
				</>
			)}
		</PromptDrawer>
	);
};

export default PwaInstallPromptDrawer;
